import React from "react";
import classNames from "classnames";
import styles from "./ContentCard.module.css";
import skeletonStyles from "./ContentCardSkeleton.module.css";

export const ContentCardSkeleton = ({ className, ...props }) => {
  return (
    <div
      className={classNames(
        styles.card,
        skeletonStyles.skeletonCard,
        className,
      )}
      {...props}
    >
      <div className={styles.imageContainer}>
        <div
          className={classNames(styles.image, skeletonStyles.skeletonImage)}
        />
        <div className={styles.activities}>
          <div className={skeletonStyles.skeletonBadge} />
          <div className={skeletonStyles.skeletonBadge} />
        </div>
      </div>
      <div className={styles.content}>
        <div
          className={classNames(styles.title, skeletonStyles.skeletonTitle)}
        />
        <div
          className={classNames(
            styles.description,
            skeletonStyles.skeletonDescription,
          )}
        />
      </div>
    </div>
  );
};
